module.exports = __webpack_public_path__ + "img/reload.b34f0e88.svg";